module.exports = [
  require('./hellenrae'),
  require('./howling_hatred_initiate'),
  require('./howling_hatred_priest'),
  require('./hurricane'),
]
